import React, { useState, useEffect, useRef } from 'react';

/* import { Link } from 'react-router-dom'; */

import Slider from "./Slider/Slider";
import Footer from "./Footer/Footer";

import parse from 'html-react-parser';

import Navbar from "./Navbar/Navbar";

import "./Pagina.css";

import * as Hosts from '../../Hosts';

import {
  set_language,
  reqGET,
  repo_img_link,
  repo_site_assets_link,
  content_language,
  translate

} from '../../Utils';

import AssecImage from "./ASSEC_Image/Image"

// get our fontawesome imports
import { faLongArrowAltRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { language } from './WEBContent/Language';

import { Navigation, Pagination, Autoplay, Scrollbar, A11y, EffectFade } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';

import "swiper/swiper-bundle.min.css";

import Modal from "./Forms/OpinionModal"
import Loader from '../../loader';
//import Swal from 'sweetalert2';

const Pagina = (props) => {
  /* variável do tipo array */

  // const Slider = React.lazy(() => import("./Slider/Slider"));

  /*const data_interface = {
    id: '',
    info: {},
    content: {
        childs: []
    }
  }*/
  //const navbar = useRef(data_interface);

  const [isloading, setLoading] = useState(true);

  const [lang, set_lang] = useState('pt');
  const [lang_id, set_lang_id] = useState('1');

  const [, set_dados] = useState(null)
  //const dados_config = useRef({})

  //const [dataProject, setDataProject] = useState([]);
  //const [dataInfo, setDataInfo] = useState([]);

  //const [dataDestaque, setDataDestaque] = useState([]);
  //const [dataBanner2, setDataBanner2] = useState([]);
  const [dataParcerias, /*setDataParcerias*/] = useState([]);
  const [dataParterships, setDataParterships] = useState([]);
  //const [dataPlatform, setDataPlatform] = useState([]);
  const [dataTestimony, setDataTestimony] = useState([]);
  //const [, setBanner] = useState([]);

  const [dataMote, setdataMote] = useState([]);
  //const [dataEtapas, setdataEtapas] = useState([]);
  //const [dataVantagens, setdataVantagens] = useState([]);
  const [dataRoutes, ] = useState([]);
  const [dataRegiaoImagens, ] = useState([]);

  const [show, setShow] = useState(false);
  //const [/*refresh*/, setRefresh] = useState(0);
  const [dados_config, set_dados_config] = useState({});
  const [dados_navbar, set_dados_navbar] = useState({});
  const banner_list = useRef([])


  /*let getInfoParcerias = async () => {
    //módulos galerias (versão antiga)
    reqGET(`${Hosts.SIMCore_API}/web/content/${Hosts.companycode}/94`)
      .then(res => {
        setDataParcerias(res.data)
        //console.log(res.data)
        setLoading(false)
      }).catch(erro => console.log('Erro parcerias', erro))
  }*/

  /*let getInfoPlatforms = async () => {
    //setLoading(true)

    reqGET(`${Hosts.SIMCore_API}/web/content/${Hosts.companycode}/52`)
      .then(res => {
        setDataPlatform(res.data)
        //console.log('PLATAFORMAS', res.data)

      })
      .catch(erro => alert('Erro'))
  }*/

  let getBanner = async () => {
    return await reqGET(`${Hosts.SIMCore_API}/web/content/type/${Hosts.companycode}/banner`)
        .then(async res => {

            if (res.data.length > 0) {

                var hoje = new Date();
                let aux = []
                res.data.forEach(async (v) => {
                    if(v.content[0].media.image !== undefined && v.content[0].media.image[0] !== undefined && v.content[0].media.image[0].link !== '') {

                        if(v.info.date.published !== undefined && v.info.date.published !== '') {
                            let date_p = new Date(v.info.date.published);
            
                            if((hoje >= date_p)) {
                                if(v.info.date.avaiable !== undefined && v.info.date.avaiable !== '') { 
                                    let date_a = new Date(v.info.date.avaiable);
                                    if(hoje <= date_a) {
                                        aux.push(v)
                                    }
                                } else{
                                    aux.push(v)
                                } 
                            }
                        }
                    }
                    else {

                        if(v.info.date.published !== undefined && v.info.date.published !== '') {
                            let date_p = new Date(v.info.date.published);
            
                            if((hoje >= date_p)) {
                                if(v.info.date.avaiable !== undefined && v.info.date.avaiable !== '') { 
                                    let date_a = new Date(v.info.date.avaiable);
                                    if(hoje <= date_a) {
                                        aux.push(v)
                                    }
                                } else{
                                    aux.push(v)
                                } 
                            }
                        }
                    }
                })
                set_dados(banner_list.current = aux)
                
            }
        })
        .catch(erro => console.log('Erro', erro))
  } 

  let getMote = async () => {
    //setLoading(true)
    reqGET(`${Hosts.SIMCore_API}/web/content/${Hosts.companycode}/230`)
      .then(res => {
        setdataMote(res.data)
        //console.log(res.data)
        //setLoading(false)
        //calculo_margem()
      })
      .catch(erro => console.log('Erro rota mote', erro))
  }

  /*let getEtapas = async () => {
    //setLoading(true)
    await reqGET(`${Hosts.SIMCore_API}/web/content/${Hosts.companycode}/229`)
      .then(res => {
        setdataEtapas(res.data)
        //setLoading(false)
        //console.log(res.data)
      })
      .catch(erro => console.log('Erro etapas', erro))
  }*/

  /*let getVantagens = async () => {
    //setLoading(true)
    await reqGET(`${Hosts.SIMCore_API}/web/content/${Hosts.companycode}/231`)
      .then(res => {
        setdataVantagens(res.data)
        //setLoading(false)
        //console.log(res.data)
      })
      .catch(erro => console.log('Erro vantagens', erro))
  }*/

  let getTestimony = async () => {
    //setLoading(true)
    reqGET(`${Hosts.SIMCore_API}/web/content/type/${Hosts.companycode}/testimony/accepted`)
      .then(res => {
        setDataTestimony(res.data.filter(v => v.info.status === 'accepted'))
        //setLoading(false)
        //console.log('Testemunhos: ', res.data.filter(v => v.info.status === 'accepted'))

      }).catch(erro => console.log('Erro rota testemunhos', erro))
  }

  let getParterships = async () => {
    //módulo Parcerias
    reqGET(`${Hosts.SIMCore_API}/web/content/slug/${Hosts.companycode}/partner_short`)
      .then(res => {

        if(res.data.length > 0) {
          setDataParterships(res.data[0].content[0]?.media?.image)
          //console.log(res.data[0].content[0]?.media?.image)
          //setLoading(false)
        }

      }).catch(erro => console.log('Erro rota parcerias', erro))
  }

  /*let getInfo = async () => {
    await reqGET(`${Hosts.SIMCore_API}/web/structure/${Hosts.companycode}`)
      .then(async res => {
          for await (let v of res.data) {
          // res.data.forEach((v) => {
              if (v.info.principal === true) {

                  if (lang !== 'pt') {
                      for await (let cl of content_language) {
                      // content_language.forEach((cl) => {
                        let x = 0
                        if (cl.code === lang) {
                          
                            v.content.childs.forEach((el) => {
                                if (el.id_content !== '') {
                                    if (el.children !== undefined) {
                                        x = x - el.children.length
                                        //for await (let el_c of el.children) {
                                        el.children.forEach(async (el_c) => {
                                            await reqGET(`${Hosts.SIMCore_API}/web/content/${Hosts.companycode}/${el_c.id_content}`)
                                                .then(res_3 => {
                                                    if (res_3.data.length > 0) {
                                                        if (res_3.data[0].info.language.length > 0) {
                                                            if (res_3.data[0].info.language[cl.id] !== undefined && res_3.data[0].info.language[cl.id] !== null) {
                                                                if (res_3.data[0].info.language[cl.id]['name'] !== '') {
                                                                    el_c.title = res_3.data[0].info.language[cl.id]['name'];

                                                                    x++
                                                                    if (v.content.childs.length === x) {
                                                                        setRefresh(refresh => refresh + 1)
                                                                    }
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            x++
                                                            if (v.content.childs.length === x) {
                                                                setRefresh(refresh => refresh + 1)
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        x++
                                                        if (v.content.childs.length === x) {
                                                            setRefresh(refresh => refresh + 1)
                                                        }
                                                    }
                                                })
                                        })
                                    }

                                    reqGET(`${Hosts.SIMCore_API}/web/content/${Hosts.companycode}/${el.id_content}`)
                                        .then(res_2 => {
                                            if (res_2.data.length > 0) {
                                                if (res_2.data[0].info.language.length > 0) {
                                                    if (res_2.data[0].info.language[cl.id] !== undefined && res_2.data[0].info.language[cl.id] !== null) {
                                                        if (res_2.data[0].info.language[cl.id]['name'] !== '') {
                                                            el.title = res_2.data[0].info.language[cl.id]['name'];

                                                            x++
                                                            if (v.content.childs.length === x) {
                                                                setRefresh(refresh => refresh + 1)
                                                            }
                                                        }
                                                    }
                                                }
                                                else {
                                                    x++
                                                    if (v.content.childs.length === x) {
                                                        setRefresh(refresh => refresh + 1)
                                                    }
                                                }
                                            }
                                            else {
                                                x++
                                                if (v.content.childs.length === x) {
                                                    setRefresh(refresh => refresh + 1)
                                                }
                                            }
                                        })


                                }
                                else {
                                    if (el['language'] !== undefined && el['language'] !== null) {
                                        if (el.language[cl.id] !== undefined && el.language[cl.id]['title'] !== undefined && el.language[cl.id]['title'] !== '') {
                                            el.title = el.language[cl.id]['title']

                                            x++
                                            if (v.content.childs.length === x) {
                                                setRefresh(refresh => refresh + 1)
                                            }
                                        }
                                    }
                                }

                            })

                        }
                      }

                  }

                  set_dados(navbar.current = v);
              }
          }
          //console.log('rota da estrutura navbar pag welcome');

      })
      .catch(erro => console.log('ERROR', erro))
  }*/

  /*let getConfig = async () => {

    await reqGET(`${Hosts.SIMCore_API}/web/settings/type/${Hosts.companycode}/settings`)
      .then(async res => {

        if(res.data.length > 0) {
          set_dados(dados_config.current = res.data[0].info?.settings)
        }

      })
      .catch(erro => console.log('Erro', erro))
  }*/

  useEffect(() => {
    if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
      set_lang('pt')
      set_language('pt')
      set_lang_id('1')
    }
    else {
      set_lang(localStorage.getItem('lang'))
      content_language.forEach(el => {
        if (el.code === localStorage.getItem('lang')) {
          set_lang_id(el.id)
        }
      })
    }

    if(props.dados_navbar !== undefined && props.dados_navbar !== null && props.dados_navbar !== '') {
      set_dados_navbar(props.dados_navbar)
    }

    if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
      set_dados_config(props.dados_config)
    }

    (async () => {
      await getBanner()
      //await getInfo()
      //await getConfig()  
      await getMote()
      //await getEtapas()
      //await getVantagens()
      await getTestimony()
      await getParterships() 

      setLoading(false)
    })()

    /*getMote()
    getEtapas()
    getVantagens()
    getTestimony()
    getParterships()*/

    //getInfoParcerias()
    //getInfoPlatforms()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  /*function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
      let j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array; 
  }*/
  

  window.addEventListener('popstate', function (e) {
    //console.error('eeeeeeee', e)
    var state = e.state;
    if (state !== null) {
      //load content with ajax
    }
  });
  //window.addEventListener("focus", async() => await on_init(setLoading));
  return (
    isloading ?

      <Loader />

    :

      <>
        <Navbar pag_welcome={true} dados_config={dados_config} dados_navbar={dados_navbar} />
        <main className='welcome'>
          <h1 className='h1-heading visually-hidden-focusable'>
            {(dados_config.company !== undefined && dados_config.company !== '' ? dados_config.company : Hosts.webSiteTitle )}
          </h1>

          <Slider dados_banner={banner_list.current} />

          <section id="mote" className="py-5">
            <div className="container">
              <div className="row">
                <div className="col-12 title-properties">
                  <h3 className="titulo-pp">
                    {language[lang].mote_title}
                  </h3>
                </div>
                <div className='col-12 mb-5'>
                  <div className="row gy-3">
                    <div className="col-12 col-md-6 col-lg-3">
                      <div className='card border-0 h-100'>
                        <img className='img-fluid card-img-top mt-4' loading="lazy" src={repo_site_assets_link("projeto1.svg")} alt={language[lang].mote_icon1_title} title={language[lang].mote_icon1_title} />
                        <div className='card-body'>
                          <div className='icon-title'>
                            {language[lang].mote_icon1_title}
                          </div>
                          <div className='icon-text'>
                            {language[lang].mote_icon1_text}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3">
                      <div className='card border-0 h-100'>
                        <img className='img-fluid card-img-top mt-4' loading="lazy" src={repo_site_assets_link("projeto2.svg")} alt={language[lang].mote_icon2_title} title={language[lang].mote_icon2_title} />
                        <div className='card-body'>
                          <div className='icon-title'>
                            {language[lang].mote_icon2_title}
                          </div>
                          <div className='icon-text'>
                            {language[lang].mote_icon2_text}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3">
                      <div className='card border-0 h-100'>
                        <img className='img-fluid card-img-top mt-4' loading="lazy" src={repo_site_assets_link("projeto3.svg")} alt={language[lang].mote_icon3_title} title={language[lang].mote_icon3_title} />
                        <div className='card-body'>
                          <div className='icon-title'>
                            {language[lang].mote_icon3_title}
                          </div>
                          <div className='icon-text'>
                            {language[lang].mote_icon3_text}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3">
                      <div className='card border-0 h-100'>
                        <img className='img-fluid card-img-top mt-4' loading="lazy" src={repo_site_assets_link("projeto4.svg")} alt={language[lang].mote_icon4_title} title={language[lang].mote_icon4_title} />
                        <div className='card-body'>
                          <div className='icon-title'>
                            {language[lang].mote_icon4_title}
                          </div>
                          <div className='icon-text'>
                            {language[lang].mote_icon4_text}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {
                  dataMote.map((v, key) => {
                    //console.log('------------> V', v)
                    //let link_mote = (v.info.slug !== undefined && v.info.slug !== '' ? Hosts.WEB_SITE_URI + '' + v.info.slug : Hosts.WEB_SITE_URI + 'pag/' + v.id);
                    let link_mote = Hosts.WEB_SITE_URI + 'project';
                    //image = v.content[0].media.image[0].link
                    return (
                      <div key={key} className="col-12 col-md-10 mx-auto">
                        {/*<div className="mb-5">
                              <h3 className="titulo-primario">
                                {lang === 'pt' || v.content[0].language === undefined ? v.content[0].title : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].title === undefined || v.content[0].language[lang_id].title === '' ? v.content[0].title : v.content[0].language[lang_id].title)}
                              </h3>
                              <p className="subtitulo-secundario">
                                {lang === 'pt' || v.content[0].language === undefined ? v.content[0].subtitle : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].subtitle === undefined || v.content[0].language[lang_id].subtitle === '' ? v.content[0].subtitle : v.content[0].language[lang_id].subtitle)}
                              </p>
                            </div>*/}
                        <div className='div-texto column-count-2'>
                          {parse(lang === 'pt' || v.content[0].language === undefined ? v.content[0].text : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].text === undefined || v.content[0].language[lang_id].text === '' ? v.content[0].text : v.content[0].language[lang_id].text))}
                        </div>
                        <div className="text-center mt-4">
                          <a href={link_mote} className="btn btn-primary" /*title={language[lang].learn_more}*/>
                            {language[lang].learn_more}
                          </a>
                        </div>
                      </div>
                    )
                  })
                }
            
              </div>
            </div>
          </section>

          <section id="banner_parallax" className="parallax" style={{ backgroundImage: `url(` + repo_img_link("banner-parallax.jpg") + `)` }}>
              <div className="container-fluid py-5 overlay-img">
                <div className="row">
                  <div className="container">
                    <div className="row">
                      <div className="col-12 title-properties">
                        <h3 className="titulo-pp text-white">
                          {language[lang].parallax_banner_title}
                        </h3>
                        <hr></hr>
                      </div>
                      <div className="col-12 text-center">
                        <h3 className="titulo-secundario font-weight-bold text-white" >
                          {parse(language[lang].parallax_banner_text)}
                        </h3>
                        <a href={Hosts.WEB_SITE_URI + 'regist/farmer'} className="btn btn-primary mt-3" /*title={language[lang].learn_more}*/>
                          {language[lang].parallax_banner_button}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </section>

          <section id="opinion" className='py-5'/*className="parallax" style={{ backgroundImage: `url(` + repo_img_link("banner-testemunhos.jpg") + `)` }}*/>
              <div className="container">
                <div className="row">
                  <div className="col-12 title-properties">
                    <h3 className="titulo-pp">
                      {language[lang].testimonials}
                    </h3>
                    <hr></hr>
                  </div>
                  <div className="col-12 col-md-9 mx-auto text-center">
                    <div className="swiper swiper-container swiper-testemunhos">
                      <Swiper
                        modules={[Autoplay, Navigation, EffectFade, Pagination, Scrollbar, A11y]}

                        speed={8000}
                        //loop={dataTestimony.length > 1 ? true : false}
                        loop={false}
                        autoplay={{
                          delay: 5000,
                          disableOnInteraction: false,
                        }}

                        spaceBetween={0}
                        //centeredSlides={true}
                        //centerInsufficientSlides={true}
                        slidesPerView={1}
                        slidesPerGroup={1}
                        //navigation
                        pagination={{
                          el: '.swiper-pagination-testemunhos',
                          clickable: true
                        }}
                        breakpoints={{
                          // when window width is >= 0px
                          /*0: {
                            slidesPerView: 1,
                          },*/
                          // when window width is >= 768px
                          768: {
                            slidesPerView: 1,
                            slidesPerGroup: 1
                          },
                          992: {
                            slidesPerView: 1,
                            slidesPerGroup: 1
                          },
                        }}
                      //scrollbar={{ draggable: true }}
                      >
                        {
                          dataTestimony.map((v, key) => {
                            return (
                              <SwiperSlide key={key} className='p-3'>
                                {/*<img src={repo_site_assets_link("aspas.svg")} alt={language[lang].testimonials} title={language[lang].testimonials} className="img-fluid mb-4" />*/}
                                <div className="testimonial-text">
                                  {parse(v.content[0].message)}
                                </div>
                                <div className='testimonial-title'>
                                  {parse(v.content[0].name)}
                                  {
                                    v.content[0].address !== '' ?
                                        <>
                                          &nbsp;&#45;&nbsp;
                                          {parse(v.content[0].address)}
                                        </>
                                      : null
                                  }
                                </div>
                                <div className="testimonial-timestamp">
                                  {/*v.info.date.creation.split('T')[0]*/}
                                  {new Date(v.info.date.creation).toLocaleDateString("pt-PT", { day: "numeric", month: "long", year: "numeric" })}
                                </div>
                              </SwiperSlide>
                            )
                          })
                        }

                      </Swiper>
                    </div>
                    <div className="swiper-pagination-testemunhos mt-2"></div>
                    <div className="col-12 mt-4 text-center d-none">
                      <button type="button" /*onClick={() => setShow(true)}*/ data-bs-toggle="modal" data-bs-target={"#opinion_modal_form"} className="btn btn-secondary">{language[lang].testimonials_button_message}</button>
                      <Modal onClose={() => setShow(false)} show={show} dados_config={dados_config} />
                    </div>
                  </div>
                </div>
              </div>
          </section>

          <section id="parcerias" className='py-5'>
            <div className="container">
              <div className="row">
                <div className="col-12 title-properties">
                  <h3 className="titulo-pp">
                    {language[lang].partnerships}
                  </h3>
                  <hr></hr>
                </div>
                {
                  dataParterships !== undefined && dataParterships !== null && dataParterships.length > 0 ?
                    <div className="col-12">
                      <div className="row row-cols-2 row-cols-sm-3 row-cols-md-5 justify-content-center g-4">
                        {
                          dataParterships.map((v, key) => {
                            //check if link has http (if not, add it to link)
                            if (v !== undefined && v !== null && v.url !== undefined && v.url !== null && v.url !== '' && v.url.substr(0, 4) !== 'http') {
                              v.url = 'http://' + v.url;
                              //console.log(v.url)
                            }
                            //console.log(v)
                            return (
                              <div className="col" key={key}>
                                <div className="card">
                                  <div className="partner-image position-relative">
                                    {
                                      v !== undefined && v !== null && v.url !== undefined && v.url !== null && v.url !== '' /*&& v.url.substr(0, 4) !== 'http'*/ ?
                                        // v !== null && v.url !== undefined && v.url !== '' ?
                                        <a aria-label={"Link - " + v.url + " (opens a new window)"} title={translate(v.name, lang)} href={v.url} target="_blank" rel="noreferrer">
                                          <AssecImage
                                            linkImage={v.link !== undefined ? v.link : repo_img_link('nophoto.png')}
                                            width="280"
                                            height="120"
                                            fit='fit'
                                            type='img'
                                            sClass='img-fluid'
                                            loading="lazy"
                                            alt={translate(v.name, lang).includes('webp') || translate(v.name, lang).includes('jpg') || translate(v.name, lang).includes('png') || translate(v.name, lang) === '' ? 'partner-logo': translate(v.name, lang) }
                                            title={v.url}
                                          />
                                        </a>
                                      :
                                        <AssecImage
                                          linkImage={v.link !== undefined ? v.link : repo_img_link('nophoto.png')}
                                          width="280"
                                          height="120"
                                          fit='fit'
                                          type='img'
                                          sClass='img-fluid'
                                          loading="lazy"
                                          alt={translate(v.name, lang).includes('webp') || translate(v.name, lang).includes('jpg') || translate(v.name, lang).includes('png') || translate(v.name, lang) === '' ? 'partner-logo': translate(v.name, lang) }
                                          title={(translate(v.name, lang).includes('webp') || translate(v.name, lang).includes('jpg') || translate(v.name, lang).includes('png') || translate(v.name, lang) === '') ? language[lang].learn_more : translate(v.name, lang)}
                                        />
                                    }
                                  </div>
                                </div>
                              </div>
                            )
                          })
                        }
                      </div>
                    </div>
                  :
                    null
                }
                {
                  dataParterships !== undefined && dataParterships !== null && dataParterships.length > 0 && 0 ?
                    //swiper carousel
                    <div className="col-12">
                      <div className="swiper-container swiper-parcerias">
                        <Swiper className="p-1"
                          modules={[Navigation, Autoplay, Pagination, Scrollbar, A11y]}
                          spaceBetween={15}
                          slidesPerView={2}
                          //slidesPerGroup={2}
                          loop={false}
                          speed={700}
                          autoplay={{
                            delay: 3000,
                            disableOnInteraction: false
                          }}
                          pagination={{
                            el: '.swiper-pagination-parcerias',
                            clickable: true
                          }}
                          breakpoints={{
                            // when window width is >= 0px
                            0: {
                              slidesPerView: 2,
                              //slidesPerGroup: 2
                            },
                            // when window width is >= 768px
                            768: {
                              slidesPerView: 3,
                              //slidesPerGroup: 3
                            },
                            992: {
                              slidesPerView: 5,
                              //slidesPerGroup: 5
                            },
                          }}
                          //scrollbar={{ draggable: true }}
                          //onSwiper={(swiper) => console.log(swiper)}
                          //onSlideChange={() => console.log('slide change')}
                        >

                          {
                            dataParterships.map((v, key) => {
                              //check if link has http (if not, add it to link)
                              if (v !== undefined && v !== null && v.url !== undefined && v.url !== null && v.url !== '' && v.url.substr(0, 4) !== 'http') {
                                v.url = 'http://' + v.url;
                                //console.log(v.url)
                              }
                              //console.log(v)
                              return (
                                <SwiperSlide key={key}>
                                  <div className="card">
                                    <div className="partner-image position-relative">
                                      {
                                        v !== undefined && v !== null && v.url !== undefined && v.url !== null && v.url !== '' /*&& v.url.substr(0, 4) !== 'http'*/ ?
                                          // v !== null && v.url !== undefined && v.url !== '' ?
                                          <a title={translate(v.name, lang)} href={v.url} target="_blank" rel="noreferrer">
                                            <AssecImage
                                              linkImage={v.link !== undefined ? v.link : repo_img_link('nophoto.png')}
                                              width="280"
                                              height="120"
                                              fit='fit'
                                              type='img'
                                              sClass='img-fluid'
                                              loading="lazy"
                                              alt={translate(v.name, lang)}
                                              title={v.url}
                                            />
                                          </a>
                                        :
                                          <AssecImage
                                            linkImage={v.link !== undefined ? v.link : repo_img_link('nophoto.png')}
                                            width="280"
                                            height="120"
                                            fit='fit'
                                            type='img'
                                            sClass='img-fluid'
                                            loading="lazy"
                                            alt={translate(v.name, lang)}
                                            title={(v.link.includes(translate(v.name, lang)) || translate(v.name, lang).includes('webp') || translate(v.name, lang).includes('jpg') || translate(v.name, lang).includes('png')) ? '' : translate(v.name, lang)}
                                          />
                                      }
                                    </div>
                                  </div>
                                </SwiperSlide>
                              )
                            })
                          }
                        </Swiper>
                      </div>
                      <div className="swiper-pagination-parcerias mt-4"></div>
                    </div>
                  :
                    null
                }
                <div className='col-12 mt-3 text-center'>
                  {language[lang].partnerships_info}
                </div>
              </div>
            </div>
          </section>

          {
            false ?
              <div>
                <section id="etapas" className="py-5">
                    <div className="container-fluid">
                      <div className="row">
                        <div className="col-12">
                          {
                            /*dataEtapas.map((v, key) => {
                              return (
                                <div className="row" key={key}>
                                  <div className="col-12 title-properties">
                                    <h3 className="titulo-pp">
                                      {lang === 'pt' || v.content[0].language === undefined ? v.content[0].title : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].title === undefined || v.content[0].language[lang_id].title === '' ? v.content[0].title : v.content[0].language[lang_id].title)}
                                    </h3>
                                  </div>
                                  <div className="col-12">
                                    <div className="row gy-4 justify-content-center">
                                      {
                                        v.content.slice(1).map((v2, key2) => {
                                          return (
                                            <div className="col-12 col-md-6 col-lg-4 col-xxl" key={key2} >
                                              <div className='etapa-container'>
                                                <div className='etapa-imagem'>
                                                  <AssecImage
                                                    linkImage={v2.media.image[0].link !== undefined ? v2.media.image[0].link : repo_img_link('nophoto.png')}
                                                    width="500"
                                                    height="500"
                                                    fit='crop'
                                                    type='img'
                                                    sClass='img-fluid'
                                                    alt={v2.title}
                                                    title={v2.title}
                                                  />
                                                </div>
                                                <div className='etapa-content'>
                                                  <div className="etapa-titulo">
                                                    {v2.title}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          )
                                        })
                                      }
                                    </div>
                                  </div>
                                </div>
                              )
                            })*/
                          }
                        </div>
                      </div>
                    </div>
                </section>

              <section id="comparativo" className="py-5">
                <div className="container">
                  <div className="row">
                    <div className="col-12 title-properties">
                      <h3 className="titulo-pp">
                        Soluções Tecnológicas e Poupança Energética
                      </h3>
                    </div>
                    <div className="col-12 col-md-6">
                      <img className='img-fluid' src={repo_site_assets_link("solucao.png")} alt="solução" title="Solução Tecnológica" />
                    </div>
                    <div className="col-12 col-md-6">
                      <img className='img-fluid' src={repo_site_assets_link("poupanca.png")} alt="poupança" title="Poupança de Energia Estimada" />
                    </div>
                  </div>
                </div>
              </section>

              <section id="vantagens" className="py-5">
                <div className="container">
                  <div className="row">
                    <div className="col-12">
                      {
                        /*dataVantagens.map((v, key) => {
                          return (
                            <div className="row" key={key}>
                              <div className="col-12 title-properties">
                                <h3 className="titulo-pp">
                                  {lang === 'pt' || v.content[0].language === undefined ? v.content[0].title : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].title === undefined || v.content[0].language[lang_id].title === '' ? v.content[0].title : v.content[0].language[lang_id].title)}
                                </h3>
                              </div>
                              <div className="col-12">
                                <div className="row gy-4 justify-content-center">
                                  {
                                    v.content.slice(1).map((v2, key2) => {
                                      return (
                                        <div className="col-12 col-md-6 col-lg-3" key={key2} >
                                          <div className="card h-100">
                                            <div className="card-img-top">
                                                <AssecImage
                                                  linkImage={v2.media.image[0].link !== undefined ? v2.media.image[0].link : repo_img_link('nophoto.png')}
                                                  width="400"
                                                  height="400"
                                                  fit='crop'
                                                  type='img'
                                                  sClass='img-fluid'
                                                  alt={v2.title}
                                                  title={v2.title}
                                                />
                                            </div>
                                            <div className="card-body">
                                                <div className="card-title">
                                                  {v2.title}
                                                </div>
                                            </div>
                                          </div>
                                        </div>
                                      )
                                    })
                                  }
                                </div>
                              </div>
                            </div>
                          )
                        })*/
                      }
                    </div>
                  </div>
                </div>
              </section>

                <section id="info_resort_fixed" className='d-none'>

                  {/*<a href={Hosts.WEB_SITE_URI + 'mapa_pistas/'} className="text-decoration-none" title={language[lang].resort_serra_da_estrela}>
                    <div className="round-card btn_04 text-center">
                      <div className='d-inline-flex'>
                        <div className='d-flex align-items-center justify-content-center mr-2'>
                          <img src={repo_site_assets_link("escola.svg")} alt={language[lang].resort_serra_da_estrela} title={language[lang].resort_serra_da_estrela} />
                        </div>
                        <div className='info-content p-2'>
                          <div className='titulo-secundario'>{language[lang].current_state}&#58;&nbsp;</div>
                          <div className={dataPistas.filter(v => v.state === true).length > 0 ? 'font-weight-bold text-uppercase text-success' : 'font-weight-bold text-uppercase text-danger'}>
                            {dataPistas.filter(v => v.state === true).length > 0 ? language[lang].open : language[lang].closed}
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>

                  <a href="https://www.meteoestrela.pt/previsoes/neve/" title={language[lang].meteorology} target="_blank" rel="noreferrer" className="text-decoration-none">
                    <div className="round-card btn_01 text-center">
                      <div className='d-inline-flex'>
                        <div className='d-flex align-items-center justify-content-center mr-2'>
                          <img src={repo_site_assets_link("meteorologia.svg")} alt={language[lang].temperature} title={language[lang].temperature} />
                        </div>
                        <div className='info-content p-2'>
                          <h6 className="titulo-secundario">{language[lang].temperature}</h6>
                          <div className="numbers">
                            <span>{dataTemperature.min}ºC</span>
                            &nbsp;&#47;&nbsp;
                            <span>{dataTemperature.max}ºC</span>
                          </div>
                          <div style={{ color: 'var(--body)'}}>
                            <span className="mr-3">min</span>
                            <span className="ml-3">max</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>

                  <a href={Hosts.WEB_SITE_URI + 'mapa_pistas/'} className="text-decoration-none" title={language[lang].tracks}>
                    <div className="round-card btn_02 text-center">
                      <div className='d-inline-flex'>
                        <div className='d-flex align-items-center justify-content-center mr-2'>
                          <img src={repo_site_assets_link("pistas.svg")} alt={language[lang].tracks} title={language[lang].tracks} />
                        </div>
                        <div className='info-content p-2'>
                          <h6 className="titulo-secundario">{language[lang].tracks}</h6>
                          <div className="numbers">
                            <span>{dataPistas.filter(v => v.state === true).length}</span>
                            &nbsp;&#47;&nbsp;
                            <span style={{ color: 'var(--body)'}}>{dataPistas.length}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                  
                  <a href={Hosts.WEB_SITE_URI + 'mapa_pistas/'} className="text-decoration-none" title={language[lang].mechanical_means}>
                    <div className="round-card btn_03 text-center mb-0">
                      <div className='d-inline-flex'>
                        <div className='d-flex align-items-center justify-content-center mr-2'>
                          <img src={repo_site_assets_link("meios-mecanicos.svg")} alt={language[lang].mechanical_means} title={language[lang].mechanical_means} />
                        </div>
                        <div className='info-content p-2'>
                          <h6 className="titulo-secundario">{language[lang].mechanical_means}</h6>
                          <div className="numbers">
                            <span>{dataMeios.filter(v => v.state === true).length}</span>
                            &nbsp;&#47;&nbsp;
                            <span style={{ color: 'var(--body)'}}>{dataMeios.length}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>*/}
                </section>

                <section id="info_resort" className='d-none'>
                  {/*<div className="container-fluid py-5">
                    <div className="container">
                      <div className="row">
                        <div className="col-12 mt-5 text-center">
                          <h3 className="titulo-primario">
                            {language[lang].resort_serra_da_estrela}
                          </h3>
                          <div className='current_state my-3'>
                            <span className='titulo-secundario'>
                              {language[lang].current_state}&#58;&nbsp;
                            </span>
                            <span className={dataPistas.filter(v => v.state === true).length > 0 ? 'font-weight-bold text-uppercase text-success' : 'font-weight-bold text-uppercase text-danger'}>
                              {dataPistas.filter(v => v.state === true).length > 0 ? language[lang].open : language[lang].closed}
                            </span>
                          </div>
                          <p>{language[lang].latest_update}&#58;&nbsp;{dataLatestUpdateDate}&nbsp;{language[lang].at}&nbsp;{dataLatestUpdateHour}</p>
                        </div>

                        <div className="col-12 mt-4">
                          <div className="row justify-content-evenly no-gutters">
                            <div className="round-card text-center">
                              <img src={repo_site_assets_link("meteorologia.svg")} alt={language[lang].temperature} title={language[lang].temperature} className="img-fluid" />
                              <h6 className="titulo-secundario">{language[lang].temperature}</h6>
                              <div className="numbers">
                                <span>{dataTemperature.min}ºC</span>
                                &nbsp;&#47;&nbsp;
                                <span>{dataTemperature.max}ºC</span>
                              </div>
                              <div>
                                <span className="mr-3">min</span>
                                <span className="ml-3">max</span>
                              </div>
                            </div>
                            <a href={Hosts.WEB_SITE_URI + 'mapa_pistas/'} className="text-decoration-none" title={language[lang].tracks}>
                              <div className="round-card text-center">
                                <img src={repo_site_assets_link("pistas.svg")} alt={language[lang].tracks} title={language[lang].tracks} className="img-fluid" />
                                <h6 className="titulo-secundario">{language[lang].tracks}</h6>
                                <div className="numbers">
                                  <span>{dataPistas.filter(v => v.state === true).length}</span>
                                  &nbsp;&#47;&nbsp;
                                  <span style={{ color: 'var(--body)'}}>{dataPistas.length}</span>
                                </div>
                              </div>
                            </a>
                            
                            <a href={Hosts.WEB_SITE_URI + 'mapa_pistas/'} className="text-decoration-none" title={language[lang].mechanical_means}>
                              <div className="round-card text-center">
                                <img src={repo_site_assets_link("meios-mecanicos.svg")} alt={language[lang].mechanical_means} title={language[lang].mechanical_means} className="img-fluid" />
                                <h6 className="titulo-secundario">{language[lang].mechanical_means}</h6>
                                <div className="numbers">
                                  <span>{dataMeios.filter(v => v.state === true).length}</span>
                                  &nbsp;&#47;&nbsp;
                                  <span style={{ color: 'var(--body)'}}>{dataMeios.length}</span>
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>*/}
                </section>

                <section id="app" className="parallax d-none" /*style={{ backgroundImage: `url(` + repo_img_link("banner-plataformas.png") + `)` }}*/>
                  <div className="container-fluid py-5">
                    <div className="container mb-4">
                      <div className="row">
                        <div className="col-12 text-center">
                          {/*dataPlatform.map((v, key) => {
                            //console.log('------------> V', v)
                            return (
                              <div key={key}>
                                <div className="mb-5">
                                  <h3 className="titulo-primario">
                                    {parse(lang === 'pt' || v.content[0].language === undefined ? v.content[0].title : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].title === undefined || v.content[0].language[lang_id].title === '' ? v.content[0].title : v.content[0].language[lang_id].title))}
                                  </h3>
                                  <p className="subtitulo-secundario">
                                    {parse(lang === 'pt' || v.content[0].language === undefined ? v.content[0].subtitle : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].subtitle === undefined || v.content[0].language[lang_id].subtitle === '' ? v.content[0].subtitle : v.content[0].language[lang_id].subtitle))}
                                  </p>
                                </div>
                                <div className="column-count-2 text-left">
                                  {parse(lang === 'pt' || v.content[0].language === undefined ? v.content[0].text : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].text === undefined || v.content[0].language[lang_id].text === '' ? v.content[0].text : v.content[0].language[lang_id].text))}
                                </div>
                                <div className="row">
                                  {v.content.slice(1).map((v2, key2) => {
                                    let color = key2 === 1 ? '' : (key2 === 0 ? '-red' : '-orange');
                                    return (
                                      //console.log('PROJECT', v.content[0].text)
                                      <div className="col-12 col-lg-4 mt-4 mt-sm-0" key={key2} >
                                        <img className="my-3" src={v2.media.image[0].link} alt={v2.title} height="80px" />
                                        <p className="titulo-primario mb-3">{v2.title}</p>
                                        {parse(v2.text)}
                                        <div className="mt-4">
                                          <a href="." className={"color" + color}>
                                            {language[lang].go_platform}
                                            <FontAwesomeIcon className="ml-2" icon={faLongArrowAltRight} />
                                          </a>
                                        </div>
                                      </div>
                                    )
                                  })
                                  }
                                </div>
                              </div>
                            )
                          })*/
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section id="programas" className='d-none'>
                  <div className="container-fluid py-5">
                    <div className="container">
                      <div className="row">
                        <div className="col-12 my-5">
                          <h2 className="titulo-primario">
                            {language[lang].programs}
                          </h2>
                          <h1 className="vertical-title-left">
                            {language[lang].programs}
                          </h1>
                        </div>
                        <div className="col-12">
                          <div className="swiper swiper-container swiper-programas">
                            <Swiper
                              modules={[Navigation, Autoplay, Pagination, Scrollbar, A11y, EffectFade]}
                              spaceBetween={15}
                              //slidesPerView={3}
                              //navigation={banner.length > 1 ? true : false}
                              /*navigation={{
                                  nextEl: '.swiper-programas-button-next',
                                  prevEl: '.swiper-programas-button-prev',
                              }}*/
                              loop={false}
                              speed={7000}
                              autoplay={{
                                delay: 5000,
                                disableOnInteraction: false
                              }}
                              //effect="fade"
                              //pagination={banner.length > 1 ? true : false}
                              pagination={{
                                el: '.swiper-pagination-programas',
                                clickable: true
                              }}
                              breakpoints={{
                                // when window width is >= 0px
                                0: {
                                  slidesPerView: 1,
                                },
                                // when window width is >= 768px
                                768: {
                                  slidesPerView: 2,
                                },
                                992: {
                                  slidesPerView: 3,
                                },
                                1200: {
                                  slidesPerView: 3,
                                },
                              }}
                            /*scrollbar={{ draggable: true }}*/
                            //onSwiper={(swiper) => console.log(swiper)}
                            //onSlideChange={() => console.log('slide change')}
                            >
                              <SwiperSlide>
                                <div className="card border-0">
                                  <div className="product-image position-relative">
                                    <a title="Programa1" href="#programas">
                                      {/*<img src={repo_site_assets_link("programa1.jpg")} alt="Programa1" title="Programa1" className="img-fluid" />*/}
                                      <div style={{ backgroundImage: `url(` + repo_site_assets_link("programa1.jpg") + `)` }} alt="Programa1" title="Programa1" className="img-fluid background-image"></div>
                                    </a>

                                  </div>
                                  <div className="product-content p-3 bg-color-gray-light">
                                    <div className="info mb-4">
                                      <span className="product-name">Forfait 2 dias</span>
                                      &nbsp;&#47;&nbsp;
                                      <span className="product-group">Adulto</span>
                                      <div className="price float-right">45,00€</div>
                                    </div>
                                    <button className="btn btn-primary float-right">{language[lang].learn_more}</button>
                                  </div>
                                </div>

                              </SwiperSlide>
                              <SwiperSlide>
                                <div className="card border-0">
                                  <div className="product-image position-relative">
                                    <a alt="Programa2" title="Programa2" href="#programas">
                                      {/*<img src={repo_site_assets_link("programa2.jpg")} alt="Programa2" title="Programa2" className="img-fluid" />*/}
                                      <div style={{ backgroundImage: `url(` + repo_site_assets_link("programa2.jpg") + `)` }} alt="Programa2" title="Programa2" className="img-fluid background-image"></div>

                                    </a>

                                  </div>
                                  <div className="product-content p-3 bg-color-gray-light">
                                    <div className="info mb-4">
                                      <span className="product-name">Forfait diário</span>
                                      &nbsp;&#47;&nbsp;
                                      <span className="product-group">Família</span>
                                      <div className="price float-right">78,00€</div>
                                    </div>
                                    <button className="btn btn-primary float-right">{language[lang].learn_more}</button>
                                  </div>
                                </div>

                              </SwiperSlide>
                              <SwiperSlide>
                                <div className="card border-0">
                                  <div className="product-image position-relative">
                                    <a alt="Programa3" title="Programa3" href="#programas">
                                      {/*<img src={repo_site_assets_link("programa3.jpg")} alt="Programa3" title="Programa3" className="img-fluid" />*/}
                                      <div style={{ backgroundImage: `url(` + repo_site_assets_link("programa3.jpg") + `)` }} alt="Programa3" title="Programa3" className="img-fluid background-image"></div>
                                    </a>

                                  </div>
                                  <div className="product-content p-3 bg-color-gray-light">
                                    <div className="info mb-4">
                                      <span className="product-name">Forfait 3 dias</span>
                                      &nbsp;&#47;&nbsp;
                                      <span className="product-group">Criança</span>
                                      <div className="price float-right">40,00€</div>
                                    </div>
                                    <button className="btn btn-primary float-right">{language[lang].learn_more}</button>
                                  </div>
                                </div>

                              </SwiperSlide>
                              <SwiperSlide>
                                <div className="card border-0">
                                  <div className="product-image position-relative">
                                    <a alt="Programa4" title="Programa4" href="#programas">
                                      <div style={{ backgroundImage: `url(` + repo_site_assets_link("programa4.jpg") + `)` }} alt="Programa4" title="Programa4" className="img-fluid background-image" ></div>
                                      {/*<img src={repo_site_assets_link("programa4.jpg")} alt="Programa4" title="Programa4" className="img-fluid" />*/}
                                    </a>

                                  </div>
                                  <div className="product-content p-3 bg-color-gray-light">
                                    <div className="info mb-4">
                                      <span className="product-name">Forfait Teste</span>
                                      &nbsp;&#47;&nbsp;
                                      <span className="product-group">All people</span>
                                      <div className="price float-right">50,00€</div>
                                    </div>
                                    <button className="btn btn-primary float-right">{language[lang].learn_more}</button>
                                  </div>
                                </div>

                              </SwiperSlide>


                              {
                                /*programas.map((v, key) => {
                                  return (
                                    <SwiperSlide key={key}>
                                      <div className='card'>
                                        <a alt="" href="/#">
                                          <img alt='' className="img-fluid" src={v.content[0].media.image[0].link} />
                                          {parse(v.info.date.published.split('T')[0])}
                                          <p><b>{parse(v.content[0].title)}</b></p>
                                          <p>{parse(v.content[0].abstract)}</p>
                                        </a>
                                      </div>
                                    </SwiperSlide>
                                  )
                                })*/
                              }

                            </Swiper>
                          </div>
                          <div className="swiper-pagination-programas my-3"></div>
                        </div>
                        <div className="col-12">
                          <div className="my-2 text-right">
                            <a className="txt-btn" href="#programas" title={language[lang].see_it_all}>
                              {language[lang].see_it_all}
                              <FontAwesomeIcon icon={faLongArrowAltRight} />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section id="destaque_11" className="parallax d-none" /*style={{ backgroundImage: `url(` + repo_img_link("banner_pag_welcome_1.jpg") + `)` }}*/>
                  <div className="container-fluid mp-mask">
                    <div className="row">
                      {/*<img alt='Snow' className="img-fluid" src={repo_img_link("banner_snow.svg")} style={{ marginTop: `-1px`}} />*/}
                      <div className="container py-100">
                        <div className="row">
                          <div className="col-12">
                            {
                              /*dataDestaque.map((v, key) => {
                              //console.log('------------> V', v)
                                let link_banner = (v.info.slug !== undefined && v.info.slug !== '' ? Hosts.WEB_SITE_URI + '' + v.info.slug : Hosts.WEB_SITE_URI + 'pag/' + v.id);
                                //image = v.content[0].media.image[0].link
                                return (
                                  <div key={key}>
                                      <div className="mb-5">
                                        <h3 className="titulo-primario">
                                          {lang === 'pt' || v.content[0].language === undefined ? v.content[0].title : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].title === undefined || v.content[0].language[lang_id].title === '' ? v.content[0].title : v.content[0].language[lang_id].title)}
                                        </h3>
                                        <p className="subtitulo-secundario">
                                          {lang === 'pt' || v.content[0].language === undefined ? v.content[0].subtitle : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].subtitle === undefined || v.content[0].language[lang_id].subtitle === '' ? v.content[0].subtitle : v.content[0].language[lang_id].subtitle)}
                                        </p>
                                      </div>
                                      <div className='d-none'>
                                        {parse(lang === 'pt' || v.content[0].language === undefined ? v.content[0].text : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].text === undefined || v.content[0].language[lang_id].text === '' ? v.content[0].text : v.content[0].language[lang_id].text))}
                                      </div>
                                      <a href={link_banner} className="btn btn-primary" title={language[lang].learn_more}>
                                        {language[lang].learn_more}
                                      </a>
                                  </div>
                                )
                              })*/
                            }
                          </div>
                        </div>
                      </div>
                      {/*<img alt='Snow' className="img-fluid" src={repo_img_link("banner_snow.svg")} style={{transform: `rotate(180deg)`, marginBottom: `-1px`}} />*/}
                    </div>
                  </div>
                </section>

                <section id="destaque_1" className="parallax" style={{ backgroundImage: `url(` + repo_img_link("banner_pag_welcome_2.jpg") + `)` }}>
                  <div className="container-fluid mp-mask">
                    <div className="row">
                      {/*<img alt='Snow' className="img-fluid" src={repo_img_link("banner_snow.svg")} style={{ marginTop: `-1px`}} />*/}
                      <div className="container py-100">
                        <div className="row">
                          <div className="col-12">
                            {
                              /*dataDestaque.map((v, key) => {
                              //console.log('------------> V', v)
                                let link_banner = (v.info.slug !== undefined && v.info.slug !== '' ? Hosts.WEB_SITE_URI + '' + v.info.slug : Hosts.WEB_SITE_URI + 'pag/' + v.id);
                                //image = v.content[0].media.image[0].link
                                return (
                                  <div key={key}>
                                      <div className="mb-5">
                                        <h3 className="titulo-primario">
                                          {lang === 'pt' || v.content[0].language === undefined ? v.content[0].title : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].title === undefined || v.content[0].language[lang_id].title === '' ? v.content[0].title : v.content[0].language[lang_id].title)}
                                        </h3>
                                        <p className="subtitulo-secundario">
                                          {lang === 'pt' || v.content[0].language === undefined ? v.content[0].subtitle : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].subtitle === undefined || v.content[0].language[lang_id].subtitle === '' ? v.content[0].subtitle : v.content[0].language[lang_id].subtitle)}
                                        </p>
                                      </div>
                                      <div className='d-none'>
                                        {parse(lang === 'pt' || v.content[0].language === undefined ? v.content[0].text : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].text === undefined || v.content[0].language[lang_id].text === '' ? v.content[0].text : v.content[0].language[lang_id].text))}
                                      </div>
                                      <a href={link_banner} className="btn btn-primary" title={language[lang].learn_more}>
                                        {language[lang].learn_more}
                                      </a>
                                  </div>
                                )
                              })*/
                            }
                          </div>
                        </div>
                      </div>
                      {/*<img alt='Snow' className="img-fluid" src={repo_img_link("banner_snow.svg")} style={{transform: `rotate(180deg)`, marginBottom: `-1px`}} />*/}
                    </div>
                  </div>
                </section>

                <section id="destaque_22" className="parallax d-none" /*style={{ backgroundImage: `url(` + repo_img_link("banner_pag_welcome_2.jpg") + `)` }}*/>
                  <div className="container-fluid mp-mask mb-0">
                    <div className="row">
                      {/*<img alt='Snow' className="img-fluid" src={repo_img_link("banner_snow.svg")} style={{ marginTop: `-1px`}} />*/}
                      <div className="container py-100">
                        <div className="row">
                          <div className="col-12 text-right">
                            {
                              /*dataBanner2.map((v, key) => {
                                //console.log('------------> V', v)
                                let link_banner = (v.info.slug !== undefined && v.info.slug !== '' ? Hosts.WEB_SITE_URI + '' + v.info.slug : Hosts.WEB_SITE_URI + 'pag/' + v.id);
                                //image = v.content[0].media.image[0].link
                                return (
                                  <div key={key}>
                                      <div className="mb-5">
                                        <h3 className="titulo-primario">
                                          {lang === 'pt' || v.content[0].language === undefined ? v.content[0].title : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].title === undefined || v.content[0].language[lang_id].title === '' ? v.content[0].title : v.content[0].language[lang_id].title)}
                                        </h3>
                                        <p className="subtitulo-secundario">
                                          {lang === 'pt' || v.content[0].language === undefined ? v.content[0].subtitle : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].subtitle === undefined || v.content[0].language[lang_id].subtitle === '' ? v.content[0].subtitle : v.content[0].language[lang_id].subtitle)}
                                        </p>
                                      </div>
                                      <div className='d-none'>
                                        {parse(lang === 'pt' || v.content[0].language === undefined ? v.content[0].text : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].text === undefined || v.content[0].language[lang_id].text === '' ? v.content[0].text : v.content[0].language[lang_id].text))}
                                      </div>
                                      <a href={link_banner} className="btn btn-primary mb-5" title={language[lang].learn_more}>
                                        {language[lang].learn_more}
                                      </a>
                                  </div>
                                )
                              })*/
                            }
                          </div>
                        </div>
                      </div>
                      {/*<img alt='Snow' className="img-fluid d-none" src={repo_img_link("banner_snow.svg")} style={{transform: `rotate(180deg)`, marginBottom: `-1px`}}/>*/}
                    </div>
                  </div>
                </section>

                <section id="destaque_2" className="parallax" style={{ backgroundImage: `url(` + repo_img_link("banner_pag_welcome_1.jpg") + `)` }}>
                  <div className="container-fluid mp-mask mb-0">
                    <div className="row">
                      {/*<img alt='Snow' className="img-fluid" src={repo_img_link("banner_snow.svg")} style={{ marginTop: `-1px`}} />*/}
                      <div className="container py-100">
                        <div className="row">
                          <div className="col-12">
                            {
                              /*dataBanner2.map((v, key) => {
                                //console.log('------------> V', v)
                                let link_banner = (v.info.slug !== undefined && v.info.slug !== '' ? Hosts.WEB_SITE_URI + '' + v.info.slug : Hosts.WEB_SITE_URI + 'pag/' + v.id);
                                //image = v.content[0].media.image[0].link
                                return (
                                  <div key={key}>
                                      <div className="mb-5">
                                        <h3 className="titulo-primario">
                                          {lang === 'pt' || v.content[0].language === undefined ? v.content[0].title : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].title === undefined || v.content[0].language[lang_id].title === '' ? v.content[0].title : v.content[0].language[lang_id].title)}
                                        </h3>
                                        <p className="subtitulo-secundario">
                                          {lang === 'pt' || v.content[0].language === undefined ? v.content[0].subtitle : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].subtitle === undefined || v.content[0].language[lang_id].subtitle === '' ? v.content[0].subtitle : v.content[0].language[lang_id].subtitle)}
                                        </p>
                                      </div>
                                      <div className='d-none'>
                                        {parse(lang === 'pt' || v.content[0].language === undefined ? v.content[0].text : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].text === undefined || v.content[0].language[lang_id].text === '' ? v.content[0].text : v.content[0].language[lang_id].text))}
                                      </div>
                                      <a href={link_banner} className="btn btn-primary mb-5" title={language[lang].learn_more}>
                                        {language[lang].learn_more}
                                      </a>
                                  </div>
                                )
                              })*/
                            }
                          </div>
                        </div>
                      </div>
                      {/*<img alt='Snow' className="img-fluid d-none" src={repo_img_link("banner_snow.svg")} style={{transform: `rotate(180deg)`, marginBottom: `-1px`}}/>*/}
                    </div>
                  </div>
                </section>

                <section id="banner_loja" className="parallax d-none" style={{ backgroundImage: `url(` + repo_img_link("banner-atendimento.jpg") + `)` }}>
                  <div className="container-fluid py-100 overlay-img">
                    <div className="row">
                      <div className="container">
                        <div className="row text-center">
                          <div className="col-12 my-5">
                            <h3 className="titulo-primario font-weight-bold text-white" /*data-bg-text={language[lang].testimonials}*/>
                              {parse(language[lang].store_banner_text)}
                            </h3>
                            <a href={Hosts.WEB_SITE_URI + 'store'} className="btn btn-secondary mt-3" /*title={language[lang].learn_more}*/>
                              {language[lang].learn_more}
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section id="rotas" className="bg-color-gray-light py-3">
                  <div className="container">
                    <div className="row">
                      <div className="col-12 my-3 my-md-5">
                        <h3 className="titulo-primario">
                          <span>{language[lang].descubra_serra}</span>
                        </h3>
                      </div>
                      {
                      dataRoutes.map((v, key) => {
                        // console.log('------------> V', v)
                        
                        let image_link = ''
                        let image_name = ''
                        let image_url = ''
                        if(v.composicao[0]['multimedia'] !== undefined && v.composicao[0]['multimedia']['link_images'] !== undefined && v.composicao[0]['multimedia']['link_images'].length > 0 ) {
                          image_link = v.composicao[0].multimedia.link_images[0][0].link
                          // image_name = v.composicao[0].multimedia.link_images[0].name
                          // image_url = v.composicao[0].multimedia.link_images[0].url
                        }
                        return (
                          <div key={key} className="col-12 col-md-6 mb-5" style={{cursor: 'pointer'}} onClick={()=> window.open(("routes/" + v.id), "_self")}>
                            <AssecImage
                              linkImage={image_link !== undefined && image_link !== '' ? image_link : repo_img_link('nophoto.webp')}
                              width="640"
                              height="305"
                              fit='crop'
                              type='img'
                              sClass='img-fluid rounded mb-4'
                              alt={image_name}
                              title={image_url}
                            />
                            <div className="mb-4">
                              <h3 className="titulo-secundario">
                                {translate(v.composicao[0].descricao.nome, lang)}
                              </h3>
                              <p className="subtitulo-secundario">
                                {translate(v.composicao[0].descricao.observacao, lang)}
                              </p>
                            </div>
                            <div className='div-dados text-center bg-white d-flex justify-content-around'>
                              <div className='my-2'>
                                <strong>{language[lang].distancia}</strong>
                                <br />
                                {v.composicao[0].distancia}
                              </div>
                              <div className='my-2'>
                                <strong>{language[lang].elevacao}</strong>
                                <br />
                                {v.composicao[0].elevacao}
                              </div>
                              <div className='d-none d-md-block my-2'>
                                <strong>{language[lang].classificacao}</strong>
                                <br />
                                ***
                              </div>
                            </div>
                            <div className='div-texto limit-10-lines'>
                              {parse(translate(v.composicao[0].descricao.descricao, lang))}
                            </div>
                          </div>
                        )
                      })
                      }
                      <div className='col-12'>
                        <div className="text-center mt-3">
                          <a href="routes/all" className="btn btn-primary" /*title={language[lang].learn_more}*/>
                            {language[lang].learn_more}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section id="regiao" className='py-3'>
                  <div className="container-fluid">
                    <div className='row'>
                      <div className="container">
                        <div className="row">
                          <div className="col-12 my-3 my-md-5">
                            <h3 className="titulo-primario">
                              <span>{language[lang].viva_usufrua}</span>
                            </h3>
                          </div>
                        </div>
                      </div>
                      <div className="container-fluid">
                        <div className="row row-cols-2 row-cols-sm-3 row-cols-md-4 row-cols-lg-6 justify-content-center">
                          {
                          //dataRegiao.map((v, _) => {
                            //return (
                              dataRegiaoImagens.map((v2, key2) => {
                              //shuffle(v.content[0].media.image).map((v2, key2) => {
                              // (v.content[0].media.image).map((v2, key2) => {
                                return (
                                  key2 < 12 ?
                                    <div key={key2} className="col p-0">
                                      <div className="partner-image position-relative">
                                        {
                                          <a
                                            href={v2.link}
                                            data-fancybox="gallery"
                                            data-caption={(v2.link.includes(v2.name) || v2.name.includes('webp') || v2.name.includes('jpg') || v2.name.includes('png')) ? '' : v2.name}
                                          >
                                            <AssecImage
                                              linkImage={v2.link !== undefined ? v2.link : repo_img_link('nophoto.png')}
                                              width="800"
                                              height="800"
                                              fit='crop'
                                              type='img'
                                              sClass='img-fluid'
                                              alt={v2.name}
                                              title={(v2.link.includes(v2.name) || v2.name.includes('webp') || v2.name.includes('jpg') || v2.name.includes('png')) ? '' : v2.name}
                                            />
                                          </a>
                                        }
                                      </div>
                                    </div>
                                  :
                                    null
                                )
                              })
                            //)
                          //})
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                {/* Parcerias (módulo parcerias)  */}
                <section id="parcerias" className='py-5'>
                  <div className="container">
                    <div className="row">
                      <div className="col-12 title-properties">
                        <h3 className="titulo-pp">
                          {language[lang].partnerships}
                        </h3>
                        <hr></hr>
                      </div>
                      {
                        dataParterships !== undefined && dataParterships !== null && dataParterships.length > 0 ?
                          <div className="col-12">
                            <div className="row row-cols-2 row-cols-sm-3 row-cols-md-5 justify-content-center g-4">
                              {
                                dataParterships.map((v, key) => {
                                  //check if link has http (if not, add it to link)
                                  if (v !== undefined && v !== null && v.url !== undefined && v.url !== null && v.url !== '' && v.url.substr(0, 4) !== 'http') {
                                    v.url = 'http://' + v.url;
                                    //console.log(v.url)
                                  }
                                  //console.log(v)
                                  return (
                                    <div className="col" key={key}>
                                      <div className="card">
                                        <div className="partner-image position-relative">
                                          {
                                            v !== undefined && v !== null && v.url !== undefined && v.url !== null && v.url !== '' /*&& v.url.substr(0, 4) !== 'http'*/ ?
                                              // v !== null && v.url !== undefined && v.url !== '' ?
                                              <a title={translate(v.name, lang)} href={v.url} target="_blank" rel="noreferrer">
                                                <AssecImage
                                                  linkImage={v.link !== undefined ? v.link : repo_img_link('nophoto.png')}
                                                  width="280"
                                                  height="120"
                                                  fit='fit'
                                                  type='img'
                                                  sClass='img-fluid'
                                                  alt={translate(v.name, lang)}
                                                  title={v.url}
                                                />
                                              </a>
                                            :
                                              <AssecImage
                                                linkImage={v.link !== undefined ? v.link : repo_img_link('nophoto.png')}
                                                width="280"
                                                height="120"
                                                fit='fit'
                                                type='img'
                                                sClass='img-fluid'
                                                alt={translate(v.name, lang)}
                                                title={(v.link.includes(translate(v.name, lang)) || translate(v.name, lang).includes('webp') || translate(v.name, lang).includes('jpg') || translate(v.name, lang).includes('png')) ? '' : translate(v.name, lang)}
                                              />
                                          }
                                        </div>
                                      </div>
                                    </div>
                                  )
                                })
                              }
                            </div>
                          </div>
                        :
                          null
                      }
                      {
                        dataParterships !== undefined && dataParterships !== null && dataParterships.length > 0 ?
                          //swiper carousel
                          <div className="col-12">
                            <div className="swiper-container swiper-parcerias">
                              <Swiper className="p-1"
                                modules={[Navigation, Autoplay, Pagination, Scrollbar, A11y]}
                                spaceBetween={15}
                                slidesPerView={2}
                                //slidesPerGroup={2}
                                loop={false}
                                speed={700}
                                autoplay={{
                                  delay: 3000,
                                  disableOnInteraction: false
                                }}
                                pagination={{
                                  el: '.swiper-pagination-parcerias',
                                  clickable: true
                                }}
                                breakpoints={{
                                  // when window width is >= 0px
                                  0: {
                                    slidesPerView: 2,
                                    //slidesPerGroup: 2
                                  },
                                  // when window width is >= 768px
                                  768: {
                                    slidesPerView: 3,
                                    //slidesPerGroup: 3
                                  },
                                  992: {
                                    slidesPerView: 5,
                                    //slidesPerGroup: 5
                                  },
                                }}
                                //scrollbar={{ draggable: true }}
                                //onSwiper={(swiper) => console.log(swiper)}
                                //onSlideChange={() => console.log('slide change')}
                              >

                                {
                                  dataParterships.map((v, key) => {
                                    //check if link has http (if not, add it to link)
                                    if (v !== undefined && v !== null && v.url !== undefined && v.url !== null && v.url !== '' && v.url.substr(0, 4) !== 'http') {
                                      v.url = 'http://' + v.url;
                                      //console.log(v.url)
                                    }
                                    //console.log(v)
                                    return (
                                      <SwiperSlide key={key}>
                                        <div className="card">
                                          <div className="partner-image position-relative">
                                            {
                                              v !== undefined && v !== null && v.url !== undefined && v.url !== null && v.url !== '' /*&& v.url.substr(0, 4) !== 'http'*/ ?
                                                // v !== null && v.url !== undefined && v.url !== '' ?
                                                <a title={translate(v.name, lang)} href={v.url} target="_blank" rel="noreferrer">
                                                  <AssecImage
                                                    linkImage={v.link !== undefined ? v.link : repo_img_link('nophoto.png')}
                                                    width="280"
                                                    height="120"
                                                    fit='fit'
                                                    type='img'
                                                    sClass='img-fluid'
                                                    alt={translate(v.name, lang)}
                                                    title={v.url}
                                                  />
                                                </a>
                                              :
                                                <AssecImage
                                                  linkImage={v.link !== undefined ? v.link : repo_img_link('nophoto.png')}
                                                  width="280"
                                                  height="120"
                                                  fit='fit'
                                                  type='img'
                                                  sClass='img-fluid'
                                                  alt={translate(v.name, lang)}
                                                  title={(v.link.includes(translate(v.name, lang)) || translate(v.name, lang).includes('webp') || translate(v.name, lang).includes('jpg') || translate(v.name, lang).includes('png')) ? '' : translate(v.name, lang)}
                                                />
                                            }
                                          </div>
                                        </div>
                                      </SwiperSlide>
                                    )
                                  })
                                }
                              </Swiper>
                            </div>
                            <div className="swiper-pagination-parcerias mt-4"></div>
                          </div>
                        :
                          null
                      }
                    </div>
                  </div>
                </section>

                {/* parcerias (módulo galerias) (versão antiga) */}
                <section id="parcerias" className='py-5'>
                  <div className="container">
                    <div className="row">
                      <div className="col-12 title-properties">
                        <h3 className="titulo-pp">
                          {language[lang].partnerships}
                        </h3>
                        <hr></hr>
                      </div>
                      <div className="col-12">
                        <div className="swiper-container swiper-parcerias">
                          <Swiper
                            modules={[Navigation, Autoplay, Pagination, Scrollbar, A11y]}
                            spaceBetween={15}
                            slidesPerView={2}
                            slidesPerGroup={2}
                            //navigation={dataParcerias.length > 1 ? true : false}
                            /*navigation={{
                                nextEl: '.swiper-parcerias-button-next',
                                prevEl: '.swiper-parcerias-button-prev',
                            }}*/
                            loop={false}
                            speed={700}
                            autoplay={{
                              delay: 3000,
                              disableOnInteraction: false
                            }}
                            pagination={{
                              el: '.swiper-pagination-parcerias',
                              clickable: true
                            }}
                            breakpoints={{
                              // when window width is >= 0px
                              0: {
                                slidesPerView: 2,
                                slidesPerGroup: 2
                              },
                              // when window width is >= 768px
                              768: {
                                slidesPerView: 3,
                                slidesPerGroup: 3
                              },
                              992: {
                                slidesPerView: 5,
                                slidesPerGroup: 5
                              },
                            }}
                            //scrollbar={{ draggable: true }}
                            //onSwiper={(swiper) => console.log(swiper)}
                            //onSlideChange={() => console.log('slide change')}
                          >
                            {
                              dataParcerias.map((v, key) => {
                                //console.log(v)
                                return (
                                  v.content[0].media.image.map((v2, key2) => {

                                    //check if link has http (if not, add it to link)
                                    if (v2 !== undefined && v2 !== null && v2.url !== undefined && v2.url !== null && v2.url !== '' && v2.url.substr(0, 4) !== 'http') {
                                      v2.url = 'http://' + v2.url;
                                      //console.log(v2.url)
                                    }
                                    //console.log(v2)
                                    return (
                                      <SwiperSlide key={key2}>
                                        <div className="card">
                                          <div className="partner-image position-relative">
                                            {
                                              v2 !== undefined && v2 !== null && v2.url !== undefined && v2.url !== null && v2.url !== '' /*&& v2.url.substr(0, 4) !== 'http'*/ ?
                                                // v2 !== null && v2.url !== undefined && v2.url !== '' ?
                                                <a alt={v2.name} href={v2.url} target="_blank" rel="noreferrer">
                                                  <AssecImage
                                                    linkImage={v2.link !== undefined ? v2.link : repo_img_link('nophoto.png')}
                                                    width="280"
                                                    height="120"
                                                    fit='fit'
                                                    type='img'
                                                    sClass='img-fluid'
                                                    alt={v2.name}
                                                    title={v2.url}
                                                  />
                                                </a>
                                              :
                                                <AssecImage
                                                  linkImage={v2.link !== undefined ? v2.link : repo_img_link('nophoto.png')}
                                                  width="280"
                                                  height="120"
                                                  fit='fit'
                                                  type='img'
                                                  sClass='img-fluid'
                                                  alt={v2.name}
                                                  title={(v2.link.includes(v2.name) || v2.name.includes('webp') || v2.name.includes('jpg') || v2.name.includes('png')) ? '' : v2.name}
                                                />
                                            }
                                          </div>
                                        </div>
                                      </SwiperSlide>
                                    )
                                  })
                                )
                              })
                            }
                          </Swiper>
                        </div>
                        <div className="swiper-pagination-parcerias mt-4"></div>
                      </div>
                      <div className="col-12">
                        <div className="row row-cols-2 row-cols-sm-3 row-cols-md-5 justify-content-center">
                          {
                            dataParcerias.map((v, key) => {
                              //console.log(v)
                              return (
                                v.content[0].media.image.map((v2, key2) => {
                                  //check if link has http (if not, add it to link)
                                  if (v2 !== undefined && v2 !== null && v2.url !== undefined && v2.url !== null && v2.url !== '' && v2.url.substr(0, 4) !== 'http') {
                                    v2.url = 'http://' + v2.url;
                                    //console.log(v2.url)
                                  }
                                  //console.log(v2)
                                  return (
                                    <div className="col mb-4" key={key2}>
                                      <div className="card">
                                        <div className="partner-image position-relative">
                                          {
                                            v2 !== undefined && v2 !== null && v2.url !== undefined && v2.url !== null && v2.url !== '' /*&& v2.url.substr(0, 4) !== 'http'*/ ?
                                              // v2 !== null && v2.url !== undefined && v2.url !== '' ?
                                              <a alt={v2.name} href={v2.url} target="_blank" rel="noreferrer">
                                                <AssecImage
                                                  linkImage={v2.link !== undefined ? v2.link : repo_img_link('nophoto.png')}
                                                  width="280"
                                                  height="120"
                                                  fit='fit'
                                                  type='img'
                                                  sClass='img-fluid'
                                                  alt={v2.name}
                                                  title={v2.url}
                                                />
                                              </a>
                                            :
                                              <AssecImage
                                                linkImage={v2.link !== undefined ? v2.link : repo_img_link('nophoto.png')}
                                                width="280"
                                                height="120"
                                                fit='fit'
                                                type='img'
                                                sClass='img-fluid'
                                                alt={v2.name}
                                                title={(v2.link.includes(v2.name) || v2.name.includes('webp') || v2.name.includes('jpg') || v2.name.includes('png')) ? '' : v2.name}
                                              />
                                          }
                                        </div>
                                      </div>
                                    </div>
                                  )
                                })
                              )
                            })
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section id="newsletter" className="parallax" style={{ backgroundImage: `url(` + repo_site_assets_link("banner_newsletter.jpg") + `)` }}>
                  <div className="container-fluid py-5 overlay-img">
                    <div className="row">
                      <div className="container">
                        <div className="row">
                          <div className="col-12 my-3 my-md-5">
                            <h3 className="titulo-primario">
                              <span>{language[lang].newsletter}</span>
                            </h3>
                          </div>
                        </div>
                      </div>
                      <div className="container">
                        <div className="row">
                          <div className="col-12 text-center">
                            <p>{language[lang].newsletter_txt}</p>
                            <div className="input-group mb-3 text-center d-flex justify-content-center">
                              <input type="text" style={{width: '100%', maxWidth: '250px'}} className="form-control" placeholder="" />
                              <div className="input-group-append">
                                <button className="btn btn-primary" type="button">{language[lang].subscribe}</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

              </div>
            :
              null
          }
        </main>

        <Footer pag_welcome={true} dados_config={dados_config} dados_navbar={dados_navbar} />

      </>
  )
}

export default Pagina;